import { render, staticRenderFns } from "./ForbiddenSiteError.vue?vue&type=template&id=4f5a32f2&scoped=true&"
import script from "./ForbiddenSiteError.vue?vue&type=script&lang=js&"
export * from "./ForbiddenSiteError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a32f2",
  null
  
)

export default component.exports